import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ConnectedNavBarWithRouter } from '../NavBar';
import { ConnectedMainWithRouter } from '../Main';
import { ConnectedLogin } from '../Login';
import { ConnectedNewUser } from '../NewUser';
import { ConnectedForgotPassword } from '../ForgotPassword';
import { ConnectedResetPassword } from '../ResetPassword';
import { ConnectedEventInformation } from '../EventInformation/EventInformation';
import { ConnectedPrivateRoute } from '../PrivateRoute';
import { AuthActions } from '../../store';
import { Spinner } from '../Spinner';
import './App.css';

const Authenticated = () => (
  <div className="app">
    <ConnectedNavBarWithRouter />
    <ConnectedMainWithRouter />
  </div>
);

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
  }

  async componentDidMount() {
    const { validateToken, refreshToken } = this.props;

    try {
      await validateToken();
    } catch (error) {
      refreshToken(`${window.location.pathname}${window.location.search}`);
    } finally {
      this.setState((state) => ({ ...state, isLoading: false }));
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="app app--loading">
          <Spinner />
        </div>
      );
    }

    return (
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/login" component={ConnectedLogin} />
          <Route exact={true} path="/invite/:token" component={ConnectedNewUser} />
          <Route exact={true} path="/forgot-password" component={ConnectedForgotPassword} />
          <Route exact={true} path="/forgot-password/:hash/:token" component={ConnectedResetPassword} />
          <Route exact={true} path="/incident-details/:building/:incident" component={ConnectedEventInformation} />
          <ConnectedPrivateRoute component={Authenticated} />
        </Switch>
      </BrowserRouter>
    );
  }
}

App.propTypes = {
  validateToken: PropTypes.func,
  refreshToken: PropTypes.func,
};

App.defaultProps = {
  validateToken: undefined,
  refreshToken: undefined,
};

const mapDispatchToProps = {
  validateToken: AuthActions.validateToken,
  refreshToken: AuthActions.refreshToken,
};

const ConnectedApp = connect(undefined, mapDispatchToProps)(App);
export { ConnectedApp };
